import React from 'react'
import styles from './ContactUs.module.css'
import { Form, Typography } from 'antd';
import { AntdInput, AntdSubmit } from '../../components';
import TextArea from 'antd/es/input/TextArea';
import AlertAction from '../../store/Actions/AlertActions';
import { useDispatch } from 'react-redux';
import ContactUsMiddleware from '../../store/Middlewares/ContactUsMiddleware';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';

function ContactUs() {
  const dispatch =  useDispatch();
  const navigate = useNavigate();
  const { Text } = Typography;
  const onFinish = (values) => {
    console.log('Success values:', values);
    if (!values.message || !values.query) {
      dispatch(AlertAction.ShowAlert({ type: "warning", message: 'All fields required' }))
    } else {
      dispatch(ContactUsMiddleware.ContactUs(values))
      dispatch(AlertAction.ShowAlert({ type: "success", message: 'Query Submitted' }))
      navigate(-1)
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
    dispatch(AlertAction.ShowAlert({ type: "warning", message: errorInfo.message }))
  };
  const [form] = Form.useForm();
  return (
    <div className={styles.mainCont}>
      <Text className={styles.subText}>{t("Contact Us")}</Text>
      <Form
        name="basic"
        form={form}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        style={{ width: '100%' }}
      >

        <div className={styles.formCont}>
          <AntdInput
            name={'query'}
            label={t('Query Title')}
            rules={[{ require: true, type: 'text', message: 'Please enter valid email' }]}
            placeholder={'Enter Title'}
            style={{ width: '60%' }}
          />
          <Form.Item labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            style={{ width: '60%' }}
            name={'message'}
            label={<p className={styles.label_style}>{t("Message Box")}</p>}
          >
            <TextArea
              rows={8}
              className={styles.input}
              style={{ border: '2px solid white', backgroundColor: 'transparent' }}
              placeholder={t('Message')}
            />
          </Form.Item>
        </div>
        <div className={styles.submitntn}>
        <AntdSubmit text={t('Submit')} buttonStyle={{ width:'100%' }} />
        </div >

      </Form >

    </div >
  )
}

export default ContactUs